import React, {useEffect, useState} from "react";
import {Btn, FormInput, FormSelect} from "./";
import {useCore} from "../hooks";
import {Schema, updateBill} from "../utils";
import {toast} from "react-toastify";

export const ProductSearch: React.FC = () => {
  const [searchPhrase, setSearchPhrase] = useState<string>('')
  const {core, setSearchString, searchType, setSearchType, checkouts, selectedCheckoutId, currentOrder, setCurrentOrder} = useCore()
  const typeOptions = [
    { label: 'Vše', value: 'all' },
    { label: 'Dostupné', value: 'available' },
    { label: 'Rezervace', value: 'reservation' },
    { label: 'Skladem', value: 'stock' },
  ]
  const filterDepotsIds = checkouts.find(c => c.id === selectedCheckoutId)?.depots?.map(d => d.id)

  useEffect(() => {
    core.services.keyEvent.onScannedBarcode.subscribe().then(barcode => {
      // toast.success(`Čárový kód načten: ${barcode}`)
      setSearchPhrase(barcode)
      setSearchString(barcode)
      core.services.product.getList({
        filters: {
          listType: 'children_and_parents_without_children',
          enabled: true,
          ean: barcode, // todo ean / code? no fulltext for speedy searching
          availability: searchType,
          depots: searchType !== 'all' ? filterDepotsIds : [],
        },
        sort: 'name',
        direction: 'ASC',
      }, Schema.product.detail).then(res => {
        if (res?.items?.length === 1) {
          const product = res.items[0]
          updateBill({ currentOrder, setCurrentOrder, product })
        }
      })
    })
    return () => {
      core.services.keyEvent.onScannedBarcode.unregisterObservers()
    }
  }, [currentOrder, core])

  return (
    <div className="flex flex-row justify-between w-1/2 lg:w-3/7 xl:w-1/2 pl-2 2xl:pl-6 items-center">
      <FormInput className="grow pr-2 !mb-0" inputclassName="w-full" value={searchPhrase} onChange={s => setSearchPhrase(s)} onSubmit={() => setSearchString(searchPhrase)} />
      <FormSelect className="pr-2 !mb-0" inputclassName="bg-base-200 border-base-200" label={''} options={typeOptions} value={searchType} onChange={t => setSearchType(t)} />
      <Btn className={'btn-primary'} icon={'fas fa-magnifying-glass'} children={'Hledat'} onClick={() => setSearchString(searchPhrase)} />
    </div>
  );
}
